<template>
    <edit-resource
        :title="title"
        :form="form"
        @close="$emit('close')"
        @submit="saveExperience"
    >

        <div class="grid grid-cols-2 gap-16">
            <datepicker v-model="form.date_from">
                {{ $t('companypage.experience_fields.date_from') }}
            </datepicker>
            <datepicker v-model="form.date_to">
                {{ $t('companypage.experience_fields.date_to') }}
            </datepicker>
            <simple-input v-model="form.company">
                {{ $t('companypage.experience_fields.company') }}
            </simple-input>
            <simple-input v-model="form.job_title">
                {{ $t('companypage.experience_fields.title') }}
            </simple-input>
            <simple-textarea class="col-span-full" v-model="form.job_description">
                {{ $t('companypage.experience_fields.description') }}
            </simple-textarea>
            <simple-textarea class="col-span-full" v-model="form.tasks">
                {{ $t('companypage.experience_fields.tasks') }}
            </simple-textarea>
        </div>

    </edit-resource>
</template>

<script>
import EditResource from './EditResource.vue';
import Input from '../forms/Input.vue';
import Experience from '../../models/Experience';
import * as experiences from '../../services/ExperienceService';
import Application from '../../models/Application';
import { normalizeJson } from '../../../shared/helpers';
import TextArea from '../forms/TextArea.vue';
import DatePicker from '../forms/DatePicker.vue';
import Form from '../../etc/forms/Form';
import moment from 'moment';
import {useRepo} from 'pinia-orm';

function getFields () {
    return [
        { name: 'company', value: ''},
        { name: 'date_from', value: ''},
        { name: 'date_to', value: ''},
        { name: 'job_title', value: ''},
        { name: 'job_description', value: ''},
        { name: 'tasks', value: ''},
    ];
}

export default {
    components: {
        'edit-resource': EditResource,
        'simple-input': Input,
        'simple-textarea': TextArea,
        'datepicker': DatePicker,
    },
    props: {
        experience: {
            type: Experience,
            required: false,
        },
        application: {
            type: Application,
            required: true,
        }
    },
    data: function () {
        return {
            form: this.generateForm(),
        }
    },
    computed: {
        title () {
            return this.$t(this.experience ? 'general.edit_subject' : 'general.add_subject', { subject: this.$t('applications.job_experience') })
        }
    },
    methods: {
        generateForm () {

            let fields = getFields();

            if (this.experience) {
                fields.forEach((field, index) => {

                    if (['date_from', 'date_to'].includes(field.name) && moment(this.experience[field.name], 'YYYY-MM-DD', true).isValid()) {
                        fields[index].value = moment(this.experience[field.name]).format('YYYY-MM-DD');
                    } else {
                        fields[index].value =  JSON.parse(JSON.stringify(this.experience[field.name]));
                    }
                });
            }

            return new Form(fields);
        },
        async saveExperience () {

            if (this.experience) {
                await this.updateExperience();
            } else {
                await this.createExperience();
            }

            this.$emit('close');
        },
        updateExperience () {
            return this.form.submit(data => experiences.update(this.experience.id, {
                data: { attributes: data },
            })).then(result => {
                return useRepo(Experience).save(normalizeJson(result));
            })
        },
        createExperience () {
            return this.form.submit(data => experiences.store(this.application.id, {
                data: {
                    attributes : data,
                    relationships: { application: { data: { id: this.application.id }}}
                }
            })).then(result => {
                return useRepo(Experience).save(normalizeJson(result));
            })
        }
    }
}
</script>
